module.exports = __webpack_public_path__ + "static/img/poster1.f2c16a60.jpg";